import React from 'react';
import axios from 'axios';
import { Button, Modal, FormGroup, ControlLabel, FormControl } from 'react-bootstrap';

var UpdatePass = React.createClass({

	getInitialState: function() {
		return {
			updateObject: {
				id: '',
				numerPass: '',
				iloscCm: '',
				ilot: '',
			}
		}
    },

		render: function() {

			return (
				<Modal show={this.props.parent.state.showUpdateModal}>
					<Modal.Header>
						<Modal.Title>Aktualizuj Listwę</Modal.Title>
					</Modal.Header>
					<Modal.Body>
					<div className="row">
						<div className="col-sm-4">
							<ControlLabel>Numer Listwy: </ControlLabel>
						</div>
						<div className="col-sm-8">
						<FormControl
							type="text"
							placeholder="Numer Listwy"
							value={this.state.updateObject.numerPass}
							onChange={this.onUpdatePassNumerChange} />
						</div>
					</div>

					<div className="row">
						<div className="col-sm-4">
							<ControlLabel>Ilość cm: </ControlLabel>
						</div>
						<div className="col-sm-8">
						<FormControl
							type="text"
							placeholder="Ilość cm"
							value={this.state.updateObject.iloscCm}
							onChange={this.onUpdatePassIloscChange} />
						</div>
					</div>

					<div className="row">
						<div className="col-sm-4">
							<ControlLabel>Ilot: </ControlLabel>
						</div>
						<div className="col-sm-8">
						<FormControl
							type="text"
							placeholder="Ilot"
							value={this.state.updateObject.ilot}
							onChange={this.onUpdatePassIlotChange} />
						</div>
					</div>


					</Modal.Body>
					<Modal.Footer>
						<Button onClick={this.props.parent.closeUpdateModal}>Zamknij</Button>
						<Button bsStyle="primary" onClick={this.onUpdateBtnClicked}>Aktualizuj</Button>
					</Modal.Footer>
				</Modal>
			);
		},

	fillUpdateObject: function() {
    	var selectedPass = this.props.parent.getPassById(this.props.parent.state.selectedPassId);

		  this.state.updateObject = {
			id: selectedPass.id,
			numerPass: selectedPass.numerPass,
			iloscCm: selectedPass.iloscCm,
			ilot: selectedPass.ilot,
		}
	},

	clearUpdateObject: function() {
		this.state.updateObject.id = '';
		this.state.updateObject.numerPass = '';
		this.state.updateObject.iloscCm = '';
		this.state.updateObject.ilot = '';
	},

	onUpdatePassNumerChange: function(event) {
		this.state.updateObject.numerPass = event.target.value;
		this.forceUpdate();
	},

	onUpdatePassIloscChange: function(event) {
		this.state.updateObject.iloscCm = event.target.value.replace(/,/g, '.');
		this.forceUpdate();
	},

	onUpdatePassIlotChange: function(event) {
		this.state.updateObject.ilot = event.target.value;
		this.forceUpdate();
	},

	onUpdateBtnClicked: function() {

		axios.put('http://217.182.200.222:8080/stanPass/' + this.state.updateObject.id, this.state.updateObject)
			.then(function (response) {
				this.props.parent.closeUpdateModal();
				this.props.parent.refreshTable();
			}.bind(this))
			.catch(function (error) {
				alert("Błędnie wprowadzone dane");
				console.log(error);
			});
	}
});

export default UpdatePass;



// WEBPACK FOOTER //
// ./src/components/StanPass/UpdatePass.js